// extracted by mini-css-extract-plugin
module.exports = {"primary":"#1084E8","dark":"undefined","pageTitle":"PageTitle-module--pageTitle--F9Yca","header":"PageTitle-module--header--2yaBQ","subtext":"PageTitle-module--subtext--1-jC-"};